<template>
  <div class="teleInfos">
    <el-card>
      <el-button type="primary" slot="header" @click="addTel()">{{$t('lang.lab_addTel')}}</el-button>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <!-- 名称 -->
        <el-table-column prop="name" :label="$t('lang.lab_telName')"></el-table-column>
        <!-- 电话 -->
        <el-table-column prop="content" :label="$t('lang.lab_tele')"></el-table-column>
        <!-- 服务时间 -->
        <el-table-column prop="serviceTime" :label="$t('lang.lab_serTime')"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope"> 
            <el-button @click="changeTel(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="delTele(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>              
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"/>
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog
        :title="titleShow"
        :visible.sync="diaIsShow"
        :close-on-click-modal="false"
        center
        top="130px"
        width="600px"
        @closed="handleDialogClosed">
        <!-- 表单验证 -->
        <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
          <!-- 名称 -->
          <el-form-item :label="$t('lang.lab_telName')" prop="input_name">
            <el-input v-model="form.input_name" :placeholder="$t('lang.lab_infoName')" maxlength="11"></el-input>
          </el-form-item>
          <!-- 电话 -->
          <el-form-item :label="$t('lang.lab_tele')" prop="input_content">
            <el-input @input="keyBA" v-model="form.input_content" :placeholder="$t('lang.lab_telNum')" maxlength="15"></el-input>
          </el-form-item>
          <!-- 服务时间 -->
          <el-form-item :label="$t('lang.lab_serTime')" prop="input_serviceTime">
            <el-input v-model="form.input_serviceTime" :placeholder="$t('lang.lab_telSerTime')" maxlength="10"></el-input>
          </el-form-item>
          <!-- 设为默认电话 -->
          <el-form-item prop="checked">
            <el-checkbox v-model="form.checked">{{$t('lang.lab_defTel')}}</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
          <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
        </div>
      </el-dialog>
   </div>
</template>

<script>
/**
 *@ClassName:teleInfo
 *@Description:电话信息
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-13
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      isDisabled: true, // 按钮置灰
      saveData: '', // 存储json字符串
      name: '', // 名称
      content: '', // 电话
      serviceTime: '', // 服务时间
      editId: '', // 接收参数
      titleShow: '', // 弹框标题
      diaIsShow: false, // 弹框是否显示
      pageNum: 1, // 页数
      pageSize: 10, // 每页数量
      pageCount: 0, // 总页数
      tableData: [], // 表单数据
      multipleSelection: [], // 多选框
      type: '', // 判断checkbox的值
      teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
      form: {
        input_name: '',
        input_content: '',
        input_serviceTime: '',
        checked: true,
      },
      rules: {
        input_name: [{ required: true, message: this.$i18n.t('lang.lab_pleInputName'), trigger: 'blur' }],
        input_content: [{ required: true, message: this.$i18n.t('lang.lab_pleInputTel'), trigger: 'blur' }]       
      },
    }
  },
  // 初始化
  created() {
    this.topics()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  // 监听小区编号
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.topics()
    },
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
      // 用户名只能输入数字
    keyBA() {
      // 仅保留数字和"."
      this.form.input_content = this.form.input_content.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.input_content.indexOf('.') < 0 && this.form.input_content != '') { 
        this.form.input_content = parseFloat(this.form.input_content)
      }
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    topics() {
      let loading = this.$loading()
      this.$get(
        `/contacts?gardenId=${this.gardenId}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加电话
    addTel() {
      this.editId = ''
      this.titleShow = this.$i18n.t('lang.lab_addTel')
      this.form.input_name = ''
      this.form.input_content = ''
      this.form.input_serviceTime = ''
      this.form.checked = true
      this.diaIsShow = true
    },
    // 修改电话信息
    changeTel(row) {
      this.editId = row.id
      this.titleShow = this.$i18n.t('lang.lab_changeTelInfo')
      this.form.input_name = row.name
      this.form.input_content = Number(row.content)
      this.form.input_serviceTime = row.serviceTime
      if (row.type === 1) {
        this.form.checked = true
      } else if (row.type === 2) {
        this.form.checked = false
      }
      this.saveData = JSON.stringify(this.form)
      this.diaIsShow = true
    },
    // 删除
    delTele(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`contacts/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.topics()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editId === '') {
            if (this.form.checked) {
              this.type = 1
            } else {
              this.type = 2
            }
            let params = {
                      gardenId: this.gardenId,
                      name: this.form.input_name,
                      content: this.form.input_content,
                      serviceTime: this.form.input_serviceTime,
                      type: this.type
                  }
            let loading = this.$loading()
            this.$post(`/contacts/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            if (this.form.checked) {
              this.type = 1
            } else {
              this.type = 2
            }
            let params = {
              gardenId: this.editId,
              type: this.type,
              name: this.form.input_name,
              content: this.form.input_content,
              serviceTime: this.form.input_serviceTime
            }
            console.log(params.type)
            this.$patch(`/contacts/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
            console.log(params.type)
          }
        }
      })
    },
    clear() {
      this.$refs.form.resetFields()
      this.form.input_name = ''
      this.form.input_content = ''
      this.form.input_serviceTime = ''
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.clear()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.topics()
    }    
  }
}
</script>

<style lang="scss">
</style>